import { render } from "./PageBarChart.vue?vue&type=template&id=1385dc6e&scoped=true"
import script from "./PageBarChart.vue?vue&type=script&lang=js"
export * from "./PageBarChart.vue?vue&type=script&lang=js"

import "./PageBarChart.vue?vue&type=style&index=0&id=1385dc6e&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1385dc6e"]])

export default __exports__